import React, { useState, useEffect } from "react";
import Pagination from "../../components/global/pagination/Pagination.jsx";
import columns from "../../columns/V2fxAccount/V2fxAcceptedAccounts.js";
import TableWithSkeleton from "../../components/global/table/TableWithSkeleton.jsx";
import { GetAllAccountApi, GetAllV2fxAccountByIdApi } from "../../api/request/account.js";
import ModalComponent from "../../components/global/modal/ModalComponent.jsx";
import moment from "moment";
import Eye from "../../assets/Eye.jsx";
import { Spin } from 'antd';

export default function Accounts({ searchText }) {
  const [isLoading, setIsLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [data, setData] = useState([]);
  const [selectedV2fxAccount, setSelectedV2fxAccount] = useState('');
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isLoadingV2fxAccountDetails, setIsLoadingV2fxAccountDetails] = useState(false);
  const [v2fxAccountDetails, setV2fxAccountDetails] = useState({});
  const [sorter, setSorter] = useState({ SortBy: 'createdDate', SortOrder: '' });

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter?.order) {
      setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
    } else {
      setSorter({ SortBy: 'createdDate', SortOrder: '' });
    }
  };

  const getAllAccounts = async () => {
    try {
      let params = {
        PageNumber: page,
        PageSize: pageSize,
        SearchText: searchText,
        FilterText: 'Approved',
        ...sorter
      }
      setIsLoading(true);
      const { data } = await GetAllAccountApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              balance: `$ ${item?.balance}`,
              createdDate: (item?.createdDate ? moment(item?.createdDate).format("DD-MM-YYYY, hh:mm A") : null),

              actions: (
                <div className="flex">
                  <button type="button" onClick={() => { setSelectedV2fxAccount(item?.terminalID); setIsOpenModal(true) }}><Eye /></button>
                </div>
              ),
            };
          })
        );
        setTotalRecord(data?.totalRecords);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getAllAccounts();
  }, [page, pageSize, searchText, filter, sorter]);

  const getV2fxAccountById = async () => {
    try {
      setIsLoadingV2fxAccountDetails(true);
      const { data } = await GetAllV2fxAccountByIdApi(selectedV2fxAccount);
      setV2fxAccountDetails(data?.data);
      setIsLoadingV2fxAccountDetails(false);
    } catch (error) {
      setIsLoadingV2fxAccountDetails(false);
    }
  }

  useEffect(() => {
    if (selectedV2fxAccount) {
      getV2fxAccountById();
    }
  }, [selectedV2fxAccount]);

  return (
    <div>
      <div className="my-6">
        <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
          <TableWithSkeleton
            columns={columns}
            data={data}
            loading={isLoading}
            onChange={handleTableChange}
            page={page}
            pageSize={pageSize}
            index={true}
          />
        </div>
        <Pagination total={totalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
      </div>

      {/* ---- V2fx Account Information ---- */}
      <ModalComponent isOpen={isOpenModal} setIsOpen={setIsOpenModal} title='V2fx Account Information' width={1300}>
        <div className='p-5'>
          {isLoadingV2fxAccountDetails ? (
            <div className="flex justify-center flex-col my-[10%]">
              <Spin size="large" />
              <p className="primary text-center mt-2">Loading...</p>
            </div>
          ) : (
            <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10 '>
              <div>
                <p className='text-base font-normal '>Full Name</p>
                <p className='text-xl primary font-semibold  mt-2'>{v2fxAccountDetails?.fullName || "--"}</p>
              </div>
              <div>
                <p className='text-base font-normal '>Account No.</p>
                <p className='text-xl primary font-semibold  mt-2'>{v2fxAccountDetails?.id || "--"}</p>
              </div>
              <div>
                <p className='text-base font-normal '>User Name</p>
                <p className='text-xl primary font-semibold  mt-2'>{v2fxAccountDetails?.v2UserName || "--"}</p>
              </div>
              <div>
                <p className='text-base font-normal '>Country</p>
                <p className='text-xl primary font-semibold  mt-2'>{v2fxAccountDetails?.country || "--"}</p>
              </div>
              <div>
                <p className='text-base font-normal '>Balance</p>
                <p className='text-xl primary font-semibold  mt-2'>$ {v2fxAccountDetails?.balance || "0"}</p>
              </div>
              <div>
                <p className='text-base font-normal '>Leverage</p>
                <p className='text-xl primary font-semibold  mt-2'>{v2fxAccountDetails?.leverage || "0"}</p>
              </div>
              <div>
                <p className='text-base font-normal '>Group</p>
                <p className='text-xl primary font-semibold  mt-2'>{v2fxAccountDetails?.groupName || '--'}</p>
              </div>
              {v2fxAccountDetails?.status && <div>
                <p className='text-base font-normal '>Status</p>
                <p className='text-xl primary font-semibold  mt-2'>{v2fxAccountDetails?.status || '--'}</p>
              </div>}
            </div>
          )}
        </div>
      </ModalComponent>
    </div>
  )
}